<template>
  <div>
    <v-dialog
      v-model="dialogVisible"
      width="500">
      <edit-note-dialog :note="currentNote"/>
    </v-dialog>
    <v-card
      v-for="item in notes"
      :key="item.id"
      class="note-card"
    >
      <v-card-text>{{item.noteText}}</v-card-text>
    </v-card>
    <v-btn
      fixed
      bottom
      dark
      fab
      right
      color="pink"
      @click="showEditNoteDialog"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script>
import {
  LOAD_NOTES_LIST_ACTION, SET_EDITED_NOTE_ACTION,
} from '../store/actions/notes-actions';
import EditNoteDialog from './EditNoteDialog.vue';

export default {
  name: 'NotesList',
  components: { EditNoteDialog },
  computed: {
    notes() {
      return this.$store.getters.notesList;
    },
    currentNote() {
      return this.$store.getters.currentNote;
    },
    dialogVisible() {
      return this.$store.getters.currentNote !== undefined;
    },
  },
  methods: {
    showEditNoteDialog() {
      this.$store.dispatch(SET_EDITED_NOTE_ACTION,
        {
          noteText: '',
          categoryId: -1,
        });
    },
  },
  mounted() {
    this.$store.dispatch(LOAD_NOTES_LIST_ACTION);
  },
};
</script>

<style scoped>
.note-card + .note-card {
  margin-top: 10px;
}
</style>
